'use client';

import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';
import { ProductRender } from '../../collection-showcase/scenes/scene-primitives.jsx';
import { referenceImages } from '../../collection-showcase/scenes/reference-brands.jsx';
import { referenceProducts } from '../../collection-showcase/scenes/reference-products.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import { _i, vi, gi, xi, yi, bi, Si } from './cash-forecast';
import { Pr, Fr, Rr, Ir } from './apps-animation';
import { WorkbookWindow, WorkbookGrid } from './workbook-grid';
export function Ci(e) {
  let t = 0,
    n = 0;
  return (
    referenceProducts.forEach((r, i) => {
      let a = _i[i] ?? 0;
      ((t += r.price * a), (n += (i === vi ? e : (gi[i] ?? 0)) * a));
    }),
    {
      retail: t,
      margin: (1 - n / t) * 100,
    }
  );
}
export const wi = [
  {
    w: '196px',
    xs: 'minmax(0,1fr)',
  },
  {
    w: '52px',
    align: 'center',
    hideSm: !0,
  },
  {
    w: '76px',
    align: 'right',
  },
  {
    w: '76px',
    align: 'right',
    hideSm: !0,
  },
  {
    w: '66px',
    align: 'right',
  },
  {
    w: '56px',
    align: 'right',
    hideSm: !0,
  },
];
export const Ti = (e) => 260 + e * 420;
export function CollectionEconomics({ t: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = e >= xi,
    n = t ? yi : (gi[vi] ?? 0),
    r = Ci(n),
    i = r.margin >= bi,
    a = [
      {
        head: !0,
        cells: [
          {
            v: 'Product',
          },
          {
            v: 'Ver.',
          },
          {
            v: 'Retail',
          },
          {
            v: 'Unit cost',
          },
          {
            v: 'Margin',
          },
          {
            v: 'Units',
          },
        ],
      },
      ...referenceProducts.map((e, r) => {
        let i = r + 2,
          a = r === vi,
          o = a ? n : (gi[r] ?? 0),
          s = referenceImages.lisiere.pieces[r];
        return {
          cells: [
            {
              at: Ti(r),
              node: (
                <span className={'flex min-w-0 items-center gap-2'}>
                  {translateShowcaseNode(
                    showcaseCopy,
                    s ? (
                      <ProductRender
                        render={s}
                        alt={translateShowcaseNode(showcaseCopy, '')}
                        className={'size-5 shrink-0 rounded-[4px]'}
                      />
                    ) : null
                  )}
                  <span className={'truncate'}>
                    {translateShowcaseNode(showcaseCopy, e.style)}
                  </span>
                </span>
              ),
            },
            {
              v: a && t ? 'v3' : a || r % 2 ? 'v2' : 'v3',
              at: Ti(r) + 40,
              tone: 'muted',
              flashKey: a && t ? 'v3' : void 0,
            },
            {
              n: e.price,
              fmt: Pr,
              at: Ti(r) + 80,
            },
            {
              v: Pr(o),
              at: Ti(r) + 120,
              flashKey: a ? String(o) : void 0,
            },
            {
              v: Fr((1 - o / e.price) * 100),
              at: Ti(r) + 220,
              f: `=1-D${i}/C${i}`,
              flashKey: a ? String(o) : void 0,
            },
            {
              n: _i[r] ?? 0,
              at: Ti(r) + 160,
            },
          ],
        };
      }),
      {
        total: !0,
        cells: [
          {
            v: 'LISI\xC8RE FW27',
            at: 2900,
          },
          {},
          {
            v: Pr(r.retail),
            at: 3150,
            f: '=SUMPRODUCT(C2:C7,F2:F7)',
          },
          {},
          {
            v: Fr(r.margin),
            at: 3850,
            f: '=1-SUMPRODUCT(D2:D7,F2:F7)/C8',
            flashKey: Fr(r.margin),
            tone: e >= Si ? (i ? 'good' : 'warn') : void 0,
          },
          {
            n: _i.reduce((e, t) => e + t, 0),
            at: 3500,
            f: '=SUM(F2:F7)',
          },
        ],
      },
      {
        cells: [
          {
            v: 'Margin target',
            at: 4e3,
            tone: 'muted',
          },
          {},
          {},
          {},
          {
            v: Fr(bi),
            at: 4100,
            tone: 'muted',
          },
          {},
        ],
      },
    ],
    o =
      e >= xi && e < 6800
        ? {
            r: 6,
            c: 3,
          }
        : Rr(a, e, 300),
    s =
      e >= xi && e < 6800
        ? {
            ref: 'D7',
            text: '=Products!Jacket.v3.cost',
            typing: !1,
          }
        : Rr(a, e, 300);
  return (
    <WorkbookWindow
      title={translateShowcaseNode(
        showcaseCopy,
        'Collection economics: LISI\xC8RE FW27'
      )}
      version={t ? 'v4' : 'v3'}
      file={'Collection-economics.sheet'}
      tabs={['Approval', 'By product', 'Channels', 'Assumptions']}
      activeTab={0}
      formula={s}
      approved={e >= 7600}
    >
      <WorkbookGrid
        label={'LISI\xC8RE FW27 collection economics'}
        columns={wi}
        rows={a}
        t={e}
        pick={o}
        extra={8}
        minRows={13}
      />
      <div className={'m-2 min-h-[164px] lg:contents'}>
        {translateShowcaseNode(
          showcaseCopy,
          e >= 4300 ? (
            <div
              className={
                'enter pop rounded-2xl p-1.5 lg:absolute lg:top-3 lg:right-3 lg:w-[284px]'
              }
            >
              <div className={'rounded-[10px] p-3'}>
                <p className={'text-ink-3 flex items-center gap-2 text-[12px]'}>
                  <ShowcaseIcon name={'link'} className={'size-4'} />
                  {translateShowcaseNode(
                    showcaseCopy,
                    'Linked to product versions'
                  )}
                </p>
                <p className={'text-ink mt-2 text-[13.5px] leading-[1.45]'}>
                  <span className={'ref ref-amber'}>
                    {translateShowcaseNode(showcaseCopy, 'LISI\xC8RE')}
                  </span>
                  {translateShowcaseNode(showcaseCopy, ' Edge jacket')}
                  {translateShowcaseNode(showcaseCopy, ' ')}
                  <span className={'num text-ink-3'}>
                    {translateShowcaseNode(
                      showcaseCopy,
                      t ? 'v2 \u2192 v3' : 'v2'
                    )}
                  </span>
                </p>
                <p className={'text-ink-3 mt-1 text-[12.5px] leading-[1.45]'}>
                  {translateShowcaseNode(
                    showcaseCopy,
                    t
                      ? 'Stock cloth instead of a custom weave: unit cost $490 \u2192 $452.'
                      : 'Waiting on the stock-cloth quote.'
                  )}
                </p>
                <p
                  className={`num mt-2.5 flex h-7 items-center gap-1.5 text-[12.5px] font-medium transition-colors duration-200 ${e < Si ? 'text-ink-4' : i ? 'text-[oklch(0.52_0.13_155)]' : 'text-[var(--ref-amber)]'}`}
                >
                  {translateShowcaseNode(
                    showcaseCopy,
                    e >= Si ? (
                      <ShowcaseIcon
                        key={'ok'}
                        name={'check'}
                        draw={'now'}
                        className={'size-4'}
                        strokeWidth={2}
                      />
                    ) : null
                  )}
                  {translateShowcaseNode(
                    showcaseCopy,
                    e < Si
                      ? `Collection margin ${Fr(r.margin)}`
                      : `${Fr(r.margin)} · meets the ${Fr(bi)} target`
                  )}
                </p>
                <p className={'text-ink-4 mt-1 text-[12px]'}>
                  {translateShowcaseNode(
                    showcaseCopy,
                    Ir(_i.reduce((e, t) => e + t, 0))
                  )}
                  {translateShowcaseNode(
                    showcaseCopy,
                    ' units \xB7 illustrative'
                  )}
                </p>
              </div>
            </div>
          ) : null
        )}
      </div>
    </WorkbookWindow>
  );
}
export const Di = [
  {
    key: 'sales',
    label: 'Sales \u221215%',
    shock: '\u221215%',
  },
  {
    key: 'fabric',
    label: 'Fabric cost +8%',
    shock: '+8%',
  },
  {
    key: 'late',
    label: 'Wholesale pays 30 days late',
    shock: '+30 d',
  },
  {
    key: 'freight',
    label: 'Freight +20%',
    shock: '+20%',
  },
];
export const Oi = {
  revenue: 1840,
  margin: 61.4,
  opex: 918,
  low: 31,
};
export function ki(e) {
  let t = Oi.revenue * (e.sales ? 0.85 : 1),
    n = Oi.margin - (e.fabric ? 1.7 : 0) - (e.freight ? 0.9 : 0);
  return {
    revenue: t,
    margin: n,
    ebitda: (t * n) / 100 - Oi.opex,
    low:
      Oi.low -
      (e.sales ? 28 : 0) -
      (e.late ? 35 : 0) -
      (e.fabric ? 6 : 0) -
      (e.freight ? 3 : 0),
  };
}
export const Ai = ki({
  sales: !1,
  fabric: !1,
  late: !1,
  freight: !1,
});
